import { ConnectorDetailPage } from '@/features/connectors';

export default function ConnectorsDetailRoute() {
  return <ConnectorDetailPage />;
}
